import ApiGuideFuneralPage from "@/views/apiGuide/ApiGuideFuneralPage.vue";
import ApiGuideCampaignPage from "@/views/apiGuide/ApiGuideCampaignPage.vue";
import ApiGuideAuthPage from "@/views/apiGuide/ApiGuideAuthPage.vue";
import PaymentModalPage from '@/views/apiGuide/PaymentModalPage.vue';

const apiGuideRoutes = [
  {
    path: "/api-guide",
    children: [
      {
        path: "api-guide-funeral",
        name: "ApiGuideFuneralPage",
        component: ApiGuideFuneralPage
      },
      {
        path: "api-guide-campaign",
        name: "ApiGuideCampaignPage",
        component: ApiGuideCampaignPage
      },
      {
        path: "api-guide-auth",
        name: "ApiGuideAuthPage",
        component: ApiGuideAuthPage
      },
      {
        path: 'payment',
        name: 'PaymentModalPage',
        components: {
          default: PaymentModalPage,
        },
        props: {
          default: true,
        },
      },
    ],
  },
]

export default apiGuideRoutes;